import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Center.css';

const propTypes = {
    isStatic: PropTypes.bool,
};

class Center extends React.Component {
    static defaultProps = {
        isStatic: false,
    };

    render() {
        return <div className={classNames(s.center, { [s.static]: this.props.isStatic })}>{this.props.children}</div>;
    }
}

Center.propTypes = propTypes;

export const CenterContainer = Center;



// WEBPACK FOOTER //
// ./app/web/src/components/containers/Center.jsx